// Kırılım grubu eklendi / dönüştürüldü sonrası KALICI bilgi bandı (spec §6.2, §18 DR4; Editor.dc.html
// alt iki kart) — kaybolan bildirim DEĞİL: kullanıcı kapatana kadar durur. `converted > 0` iken
// "N değer raporlanan değere dönüştü; üyeler girilince toplam hesaplanır." (`role=status`, Kapat).
// Hata varyantı "Kaydedilemedi — hiçbir değer değişmedi" (`role=alert`) amber — asla kırmızı.
// Task 14 (BreakdownGroupModal) / Task 15 (Kırılıma dönüştür) bağlar; burada yalnız bileşen.

import { KPI_BREAKDOWN_COPY as C } from "../../lib/kpi-breakdown-copy";

export type KpiBreakdownConvertedBandProps =
  | { kind: "converted"; converted: number; onClose: () => void }
  | { kind: "failed"; detail?: string | undefined };

const dot = (color: string): JSX.Element => (
  <span
    aria-hidden="true"
    style={{ width: 10, height: 10, borderRadius: "50%", background: color, flex: "none" }}
  />
);

export function KpiBreakdownConvertedBand(
  props: KpiBreakdownConvertedBandProps,
): JSX.Element | null {
  if (props.kind === "failed") {
    return (
      <div
        role="alert"
        data-testid="kpi-breakdown-save-failed"
        className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm"
        style={{
          background: "var(--color-warning-bg)",
          border: "1px solid var(--color-warning-border)",
          color: "var(--color-warning-text)",
        }}
      >
        {dot("var(--color-warning-text)")}
        <div style={{ flex: 1 }}>
          <strong>{C.saveFailed}</strong>
          {props.detail ? <span> — {props.detail}</span> : null}
        </div>
      </div>
    );
  }
  if (props.converted <= 0) return null;
  return (
    <div
      role="status"
      data-testid="kpi-breakdown-converted-band"
      className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm"
      style={{
        background: "color-mix(in srgb, var(--color-primary) 6%, white)",
        border: "1px solid var(--color-border)",
        color: "var(--color-text)",
      }}
    >
      {dot("var(--color-primary)")}
      <div style={{ flex: 1 }}>{C.convertedBand(props.converted)}</div>
      <button
        type="button"
        onClick={props.onClose}
        className="px-3 rounded-md text-sm"
        style={{
          border: "1px solid var(--color-border)",
          color: "var(--color-text-3)",
          background: "var(--color-surface)",
          minHeight: 32,
          fontWeight: 600,
        }}
      >
        {C.convertedBandClose}
      </button>
    </div>
  );
}
